import DropDown from "./components/Dropdown.vue";
import vSelect from 'vue-select'
import SelectList from "./components/FormGenerator/SelectList";
import './assets/css/vue-select.css';
import { VclTable } from "vue-content-loading";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component('v-select', vSelect);
    Vue.component('horus-select', SelectList);
    Vue.component('vcl-table', VclTable);
  }
};

export default GlobalComponents;
